<template>
    <section class="flex-column ml-n2 mr-n2">
        <div class="block block-rounded block-bordered">
            <div class="block-header">
                <div class="block-title">
                    SMS - Inbound Messages
                </div>
            </div>
            <div class="block-content-full border-top">
                <div class="row ml-0 mt-3 mb-0 mr-0">
                    <div class="col-md-5">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-light dropdown-toggle dropdown-toggle-split"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Filters
                                        &nbsp;
                                    </button>
                                    <div class="dropdown-menu">
                                        <a @click="addFilter('network_status:deliveredtoterminal')" class="dropdown-item"
                                           href="javascript:void(0)">
                                            <i class="far fa-fw fa-check-square mr-1"></i> Delivered Messages
                                        </a>
                                        <a @click="addFilter('status:senttocallback')" class="dropdown-item"
                                           href="javascript:void(0)">
                                            <i class="far fa-fw fa-envelope mr-1"></i> Unsent Messages
                                        </a>
                                        <a @click="addFilter('status:failed')" class="dropdown-item"
                                           href="javascript:void(0)">
                                            <i class="fa fa-fw fa-exclamation-triangle mr-1"></i> Failed Messages
                                        </a>
                                    </div>
                                </div>
                                <input v-model="query" type="text" class="form-control form-control-alt"
                                       id="example-group4-input1-alt" name="example-group4-input1-alt"
                                       placeholder="Search and Filters" aria-label="Text input with dropdown button">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <span class="row mb-2 mr-0 ml-0">
                            <el-date-picker
                                    v-model="dateRange"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="Start date"
                                    end-placeholder="End date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </span>
                    </div>
                    <div class="col-md-4">
                        <span class="float-right">
                            <el-button-group>
                                <el-button @click="getMessages(1)" :loading="loading" type="success"
                                           icon="el-icon-check">Apply Filters
                                </el-button>
                            </el-button-group>
                        </span>
                    </div>
                </div>
                <div class="border-top">
                    <div class="col-sm-12 m-2" v-if="searchFilters.length > 0">
                        <el-tag v-for="(filter, idx) of searchFilters" size="small" closable :key="idx"
                                @close="removeFilter(idx)" effect="plain">
                            {{filter}}
                        </el-tag>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-fit table-striped border">
                        <thead>
                        <tr>
                            <th>Short Code</th>
                            <th>Phone Number</th>
                            <th>Customer Message</th>
                            <th>Response</th>
                            <th>Network</th>
                            <th>Delivery Status</th>
                            <th>Status</th>
                            <th style="width: 150px">Sent At</th>
                            <th style="width: 150px">Delivered At</th>
                            <th>..</th>
                        </tr>
                        </thead>
                        <tbody class="small font-w500">
                        <tr v-for="(message, index) in messages" :key="index"
                            v-if="messages.length > 0">
                            <td>{{message.shortCode}}</td>
                            <td>{{message.phoneNumber}}</td>
                            <td>{{message.message}}</td>
                            <td>{{message.reply}}</td>
                            <td>{{message.network}}</td>
                            <td>{{message.networkStatus}}</td>
                            <td><small class="font-w700">{{message.status.toString().toUpperCase()}}</small>
                            <td><small>{{message.sentAt}}</small></td>
                            <td><small>{{message.deliveredAt}}</small></td>
                            <td>...</td>
                        </tr>
                        <tr v-if="!loading && messages.length === 0">
                            <td colspan="10" class="text-center">Nothing to display</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="block-content-full" v-if="messages.length > 0">
                    <div class="mr-2 mb-2 float-right">
                        <el-button-group>
                            <el-button size="small" @click="getMessages(1)"
                                       :disabled="loading || pagination.current_page < 3" type="primary"
                                       icon="el-icon-d-arrow-left"/>
                            <el-button size="small" @click="getMessages(--pagination.current_page)"
                                       :disabled="loading || pagination.current_page === 1" type="primary"
                                       icon="el-icon-arrow-left">Previous Page
                            </el-button>
                            <el-button size="small" :disabled="loading || pagination.next_page_url === null"
                                       @click="getMessages(++pagination.current_page)" type="primary">Next Page<i
                                    class="el-icon-arrow-right el-icon-right"></i>
                            </el-button>
                        </el-button-group>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {APP_CONFIG} from "../../config";
import * as moment from 'moment';
import {axios} from '../../bootstrap'

export default {
    name: "BulkOutbox",
    data() {
        return {
            loading: false,
            exportOutboxDialog: false,
            query: '',
            params: {},
            searchFilters: [],
            reportName: '',
            pagination: {},
            dateRange: [
                moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')
            ],
            messages: []
        }
    },
    mounted() {
        this.getMessages();
    },
    methods: {
        addFilter(filter) {
            this.searchFilters.push(filter);
            this.searchFilters = _.uniq(this.searchFilters)
        },
        removeFilter(idx) {
            this.searchFilters.splice(idx, 1)
        },

        getQueryParams() {
            this.params = {period: this.dateRange};
            if (this.searchFilters.length > 0 && this.query.length > 0) {
                this.params['search'] = `${this.query};` + this.searchFilters.join(';');
                this.params['searchJoin'] = 'and';
            }
            if (this.searchFilters.length > 0 && this.query.length === 0) {
                this.params['search'] = this.searchFilters.join(';');
                this.params['searchJoin'] = 'and';
            }
            if (this.searchFilters.length === 0 && this.query.length > 0) {
                this.params['search'] = this.query
            }
        },
        getMessages(page = 1) {
            this.loading = true;
            this.getQueryParams();
            this.params['page'] = page;
            axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/sms/inbox`, {
                params: this.params
            }).then(res => {
                this.messages = res.data.data;
                this.pagination = res.data.meta.custom.pagination
                //this.transactions.meta = res.data.meta.pagination;
            }).finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>
.el-select .el-input {
    width: 100%;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>
